import styles from './DesktopRecoveryComponent.module.css';
import { BentoCard } from './BentoCard';

export const DesktopRecoveryComponent = ({
  className,
}: {
  className?: string;
}) => {
    return (
      <div className={className ? `${styles.root} ${className}` : styles.root}>
        <div className="top">
          <h2>Where you and yours feel most at Home</h2>
          <p>
            Understand how to make your space better. Your Room Score reflects
            the current state of your home. Access insights on air quality,
            light exposure, temperature, noise, and humidity.
          </p>
        </div>

        <BentoCard
          gridColumn="1 / span 6"
          gridRow="2 / 3"
          caption="ROOM SCORE"
          title="Your environment, decoded"
          alt="Your space, decoded"
          textColor="#ffffff"
          bgGradient="radial-gradient(108.68% 108.68% at 50% -8.68%, #09CC6E 0%, #000 81.42%)"
          textAlign="center"
          image="web_v2/home/bento-new/room-score-lg.png"
          parentType="grid"
        />

        <BentoCard
          gridColumn="7 / span 5"
          gridRow="2 / 3"
          caption="Environment contributors"
          title="A breakdown of your environment"
          alt="The anatomy of your environment"
          textColor="#000000"
          bgColor="#ffffff"
          textAlign="center"
          image="web_v2/home/bento-new/environment-lg.png"
          colReverse
          parentType="grid"
          imagePosition="top"
        />

        <BentoCard
          gridColumn="1 / span 4"
          gridRow="3 / 4"
          caption="NOISE DETECTION"
          title={
            <>
              Understand your
              <br />
              environment&apos;s noise levels
            </>
          }
          alt="For a more quieter space"
          textColor="#ffffff"
          textAlign="left"
          bgImage="/web_v2/home/bento-new/noise-lg.png"
          parentType="grid"
        />

        <BentoCard
          gridColumn="5 / span 7"
          gridRow="3 / 4"
          caption="AIR QUALITY"
          title="Understand your air quality"
          alt="Your space, decoded"
          textColor="#ffffff"
          bgImage="/web_v2/home/bento-new/air-quality-bg-lg.png"
          textAlign="left"
          image="web_v2/home/bento-new/air-quality-lg-v2.png"
          parentType="grid"
        />

        <BentoCard
          gridColumn="1 / span 5"
          gridRow="4 / 5"
          caption="ENVIRONMENTAL SCORE"
          title={
            <>
              Create a restful
              <br />
              environment
            </>
          }
          alt="For a more quieter space"
          textColor="#ffffff"
          textAlign="center"
          bgImage="/web_v2/home/bento-new/env-score-lg.png"
          parentType="grid"
        />

        <BentoCard
          gridColumn="6 / span 6"
          gridRow="4 / 5"
          caption="LIGHT EXPOSURE"
          title={
            <>
              Align with your
              <br />
              circadian rhythm
            </>
          }
          alt="For a more quieter space"
          textColor="#000000"
          textAlign="center"
          bgImage="/web_v2/home/bento-new/light-exp-bg-lg.png"
          image="web_v2/home/bento-new/light-exp-lg.png"
          parentType="grid"
          imagePosition="bottom"
        />
      </div>
    );
};
